function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.28 14.38a.867.867 0 0 0-.867.867v1.544a1.45 1.45 0 0 1-1.448 1.448H3.209a1.45 1.45 0 0 1-1.448-1.448V3.209c0-.798.65-1.448 1.448-1.448h7.756c.799 0 1.448.65 1.448 1.448v1.544a.867.867 0 0 0 1.734 0V3.209A3.186 3.186 0 0 0 10.965.027H3.209A3.186 3.186 0 0 0 .027 3.209v13.582a3.186 3.186 0 0 0 3.182 3.182h7.756a3.186 3.186 0 0 0 3.182-3.182v-1.544a.867.867 0 0 0-.867-.867z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.38 8.607L17.654 6.88a.867.867 0 0 0-1.227 1.226l1.067 1.067H8.457a.867.867 0 1 0 0 1.734h9.036l-1.067 1.066a.867.867 0 1 0 1.226 1.226l1.729-1.728c.789-.79.789-2.074 0-2.863z"
}));

var SvgExit = function SvgExit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/exit.ac21434c.svg";
export { ForwardRef as ReactComponent };